import { ComponentProps, ReactElement } from 'react';
import { CardGrid } from '@weareopenr/component-library';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';

export interface IMenuSectionCardGridProps {
  sectionId: string;
  isDragEnabled: boolean;
  sortableItemIds: string[];
  cards: ComponentProps<typeof CardGrid>['children'];
}

const MenuSectionCardGrid = ({
  sectionId,
  isDragEnabled,
  sortableItemIds,
  cards,
}: IMenuSectionCardGridProps): ReactElement => {
  const grid = <CardGrid data-cy="card-container">{cards}</CardGrid>;

  if (!isDragEnabled) return grid;

  return (
    <SortableContext id={sectionId} items={sortableItemIds} strategy={rectSortingStrategy}>
      {grid}
    </SortableContext>
  );
};

export default MenuSectionCardGrid;
